module.exports = __webpack_public_path__ + "static/media/mail.5dc22f50.svg";